import { TextOnlyHeroBannerPropsMode } from "@models/hero-banner";
import React from "react";
import BreadCrumbs from "../BreadCrumbs";
import ImageRenderer from "../Image";
import NavItem from "../Layout/NavItem";
import { motion } from "framer-motion";
import { isEmpty } from "@utils/common";
import Title from "../Title";
import NewLink from "../NewLink";

// const wrapperVariant: Variants = {
//   end: {
//     transition: {
//       staggerChildren: 0.2,
//     },
//   },
// };

// const animationVariant: Variants = {
//   start: {
//     opacity: 0,
//   },
//   end: {
//     opacity: 1,
//   },
// };

const TextOnlyHeroBanner: React.FunctionComponent<
  TextOnlyHeroBannerPropsMode
> = ({
  title,
  bigHeader,
  description,
  ctaBtnText,
  ctaBtnLink,
  path,
  appendToPath = "",
  secondaryNav,
  author,
  bgColor,
  fontColor,
}) => {
  const mainHeaderDataObjects = secondaryNav?.items?.data ?? [];

  const renderTextAndButton = () => {
    return (
      <div className="flex justify-between relative gap-16">
        <div className="flex flex-col items-center w-full">
          <motion.div
            className="text-center xl:text-left text-primary-orange-50 font-bold text-2xl leading-[48px]"

            // variants={animationVariant}
          >
            {title}
          </motion.div>
          <motion.div
            className="pb-2"
            //  variants={animationVariant}
          >
            {bigHeader && (
              <Title
                variant="primary"
                titleText={bigHeader}
                className="text-white text-center xl:text-center max-w-none md:max-w-[70%] xl:max-w-[70%] mx-auto"
                style={{ color: fontColor ?? "#ffffff" }}
              />
            )}
          </motion.div>
          <motion.div
          // variants={animationVariant}
          >
            {description && (
              <Title
                variant="paragraph"
                titleText={description}
                className="text-white text-center mt-[22px] md:max-w-[60%] mx-auto"
                style={{ color: fontColor ?? "#ffffff" }}
              />
            )}
          </motion.div>
          {ctaBtnLink && (
            <motion.div
              className="mt-8 xl:mt-12"
              // variants={animationVariant}
            >
              <NewLink variant="primary" href={ctaBtnLink}>
                {ctaBtnText}
              </NewLink>
            </motion.div>
          )}
        </div>
      </div>
    );
  };

  const renderSecondaryNavigation = () => {
    return (
      <ul className="flex gap-8">
        {mainHeaderDataObjects?.map((oneMainHeaderDataObject) => {
          const { attributes } = oneMainHeaderDataObject ?? {};
          return (
            <NavItem
              navAttributes={attributes}
              key={oneMainHeaderDataObject.id}
              showBanner={false}
            />
          );
        })}
      </ul>
    );
  };

  const renderAuthor = () => {
    if (!author || isEmpty(author)) return <></>;

    return (
      <div className="flex justify-center mt-8">
        {author.map((oneAuthor) => {
          const {
            id,
            firstName = "",
            lastName = "",
            profilePicture,
            subTitle = "",
          } = oneAuthor;
          return (
            <div
              className="flex text-white items-center justify-center"
              key={id}
            >
              <div className="w-16 h-16 rounded-full mr-3 overflow-hidden">
                <ImageRenderer
                  image={profilePicture}
                  alt={`${firstName} ${lastName}`}
                />
              </div>
              <div className="flex flex-col justify-center">
                <div className="text-white text-lg font-semibold">
                  {firstName + " " + lastName}
                </div>
                <div className="text-white text-base font-normal">
                  {subTitle}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <motion.div
      className="bg-dark-purple-50 px-8 py-8 md:px-20 xl:px-[140px] md:py-20 items-center flex flex-col"
      initial="start"
      animate="end"
      style={{
        backgroundColor: bgColor ?? "#291E30",
      }}
      // variants={wrapperVariant}
    >
      <motion.div
        className="text-white flex justify-between"
        // variants={animationVariant}
      >
        <BreadCrumbs path={path ?? ""} appendToPath={appendToPath} />
        <div className="hidden md:flex">{renderSecondaryNavigation()}</div>
      </motion.div>
      <div className="w-full flex justify-center overflow-hidden">
        <div className="">{renderTextAndButton()}</div>
      </div>
      <motion.div className="px-4 md:px-8 lg:px-14 xl:px-[108px]">
        {renderAuthor()}
      </motion.div>
    </motion.div>
  );
};
export default TextOnlyHeroBanner;
